import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Box, Card, CardContent, CardHeader, Grid, IconButton } from '@mui/material';
import { Add } from '@mui/icons-material';
import Copy from 'components/common/Copy';
import { CarModel } from 'models/StockModel';
import useCarModals from 'modules/cars/hooks/useCarModals';
import auth from 'recoil/atoms/auth';
import { CompanyType } from 'models/CompanyModel';


type YardCardProps = {
    car: CarModel,
}

const DestinationYardCard = ({car}: YardCardProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');
    const {openYardModal} = useCarModals();

    if (my.type !== CompanyType.Master)
        return null;

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={t('destination_yard')}
                action={my.type === CompanyType.Master && <IconButton
                    onClick={() => openYardModal([car], false)}
                    size="small"
                >
                    <Add/>
                </IconButton>}
            />
            {car.destinationYard && (
                <CardContent>
                    <Box>
                        <Grid container spacing={1}>
                            <Grid item display="flex" alignItems="center">
                                {car.destinationYard.name}
                            </Grid>
                            <Grid
                                item xs={11}
                                sx={{fontSize: 'smaller', color: 'text.disabled'}}
                            >
                                {car.destinationYard.address}
                            </Grid>
                            <Grid item xs={1}>
                                <Copy value={car.destinationYard.address}/>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            )}
        </Card>
    );
};

export default DestinationYardCard;
